export default {
  HOME: "HOME",
  SEARCH: "SEARCH",
  DATAVIEW: "DATAVIEW",
  DATAVIEWADMIN: "DATAVIEWADMIN",
  ABOUT: "ABOUT",
  FILES: "FILES",
  DOCUMENT_DETAIL: "DOCUMENT_DETAIL"
};
